module.exports = __webpack_public_path__ + "static/media/smart.a110fd23.svg";